/* globals process */
/**
 * Created by Josef Jurca on 06/10/2017.
 */

import React from 'react'; // eslint-disable-line no-unused-vars

/**
 * Returns page with current version number.
 *
 * @returns {Object} JSX element.
 */
function Version () {
    return (<p>{process.env.PACKAGE_VERSION}</p>);
}

export default Version;


// WEBPACK FOOTER //
// ./src/js/components/pages/version.jsx